import React, { useState } from 'react';

const SPECHEAT_AL = 900;  // Floor material
const DENSITY_AL = 2700;
const SPECHEAT_KEMLITE = 1850; // Cover material
const DENSITY_KEMLITE = 1400;

const t_solid_floor_default = 0.005;
const t_cover_default = 0.002;
const t_roof_default = 0.0762;
const t_floor_default = 0.0762;
const t_front_default = 0.1016;
const t_rear_default = 0.0762;
const t_sides_default = 0.0508;

// "thermal_mass" here is specific heat * density = J/K.kg * kg/m3 = J / (K m3)
const insulation_dict = {
    "Polyurethane": { "conductivity": 0.025, "thermal_mass": 45000, "rho_SI": 30, "c_SI": 1500 },
    "Styrofoam": { "conductivity": 0.033, "thermal_mass": 43500, "rho_SI": 29, "c_SI": 1500 },
    "Fiberglass": { "conductivity": 0.035, "thermal_mass": 44100 },
    "Plywood": { "conductivity": 0.11, "thermal_mass": 1222000 },
    "Aluminium": { "conductivity": 50, "thermal_mass": SPECHEAT_AL * DENSITY_AL },
    "Kemlite": { "conductivity": 0.2, "thermal_mass": SPECHEAT_KEMLITE * DENSITY_KEMLITE }
};

function calculateUAParameters(
    length, width, height,
    material = {
        'Roof': ['Polyurethane', t_roof_default],
        'Floor': ['Polyurethane', t_floor_default],
        'Front': ['Polyurethane', t_front_default],
        'Rear': ['Polyurethane', t_rear_default],
        'Sides': ['Polyurethane', t_sides_default]
    },
    additional_material = {
        'Cover Material': ['Kemlite', t_cover_default],
        'Floor Material': ['Aluminium', t_solid_floor_default]
    }
) {
      const convertionsCalc=(val)=>{
    return val/1000;
  }
    // Get constants
    const k_roof = insulation_dict[material['Roof'][0]].conductivity;
    const k_floor = insulation_dict[material['Floor'][0]].conductivity;
    const k_front = insulation_dict[material['Front'][0]].conductivity;
    const k_rear = insulation_dict[material['Rear'][0]].conductivity;
    const k_sides = insulation_dict[material['Sides'][0]].conductivity;
    const k_cover = insulation_dict[additional_material['Cover Material'][0]].conductivity;
    const k_solid_floor = insulation_dict[additional_material['Floor Material'][0]].conductivity;

    const Cp_roof = insulation_dict[material['Roof'][0]].thermal_mass;
    const Cp_floor = insulation_dict[material['Floor'][0]].thermal_mass;
    const Cp_front = insulation_dict[material['Front'][0]].thermal_mass;
    const Cp_rear = insulation_dict[material['Rear'][0]].thermal_mass;
    const Cp_sides = insulation_dict[material['Sides'][0]].thermal_mass;
    const Cp_cover = insulation_dict[additional_material['Cover Material'][0]].thermal_mass;
    const Cp_solid_floor = insulation_dict[additional_material['Floor Material'][0]].thermal_mass;

    // Determine dimensions:
    // thickness of insulation
    const t_roof = convertionsCalc(material['Roof'][1]);
    const t_floor = convertionsCalc(material['Floor'][1]);
    const t_front = convertionsCalc(material['Front'][1]);
    const t_rear = convertionsCalc(material['Rear'][1]);
    const t_sides = convertionsCalc(material['Sides'][1]);
    // const t_cover = convertionsCalc(additional_material['Cover Material'][1]);
    // const t_solid_floor = convertionsCalc(additional_material['Floor Material'][1]);
    const t_cover = additional_material['Cover Material'][1];
    const t_solid_floor = additional_material['Floor Material'][1];

    // internal lengths
    const Li = length - t_front - t_rear;
    const Wi = width - 2 * t_sides;
    const Hi = height - t_floor - t_roof;

    // Outer areas
    const A_roof = length * width;
    const A_floor = A_roof;
    const A_front = width * height;
    const A_rear = A_front;
    const A_sides = 2 * length * height;

    // Internal areas
    const Ai_roof = Li * Wi;
    const Ai_floor = Ai_roof;
    const Ai_front = Wi * Hi;
    const Ai_rear = Ai_front;
    const Ai_sides = 2 * Li * Hi;

    // final parameter SI.HeatCapacity
    const C_roof = (Cp_roof * A_roof * t_roof) + (Cp_cover * Ai_roof * t_cover);
    const C_floor = (Cp_floor * A_floor * t_floor) + (Cp_cover * Ai_floor * t_cover) + (Cp_solid_floor * Ai_floor * t_solid_floor);
    const C_front = (Cp_front * A_front * t_front) + (Cp_cover * Ai_front * t_cover);
    const C_rear = (Cp_rear * A_rear * t_rear) + (Cp_cover * Ai_rear * t_cover);
    const C_sides = (Cp_sides * A_sides * t_sides) + (Cp_cover * Ai_sides * t_cover);
    const C_box = C_roof + C_floor + C_front + C_rear + C_sides;

    // Thermal resistance calculation
    const R_solid_floor = t_solid_floor / k_solid_floor;
    const R_cover = t_cover / k_cover;
    const R_roof = t_roof / k_roof;
    const R_floor = t_floor / k_floor;
    const R_front = t_front / k_front;
    const R_rear = t_rear / k_rear;
    const R_sides = t_sides / k_sides;

    // UA calculation
    const UA_roof = 1 / (R_roof / A_roof + R_cover / Ai_roof);
    const UA_floor = 1 / (R_floor / A_floor + R_cover / Ai_floor + R_solid_floor / Ai_floor);
    const UA_front = 1 / (R_front / A_front + R_cover / Ai_front);
    const UA_rear = 1 / (R_rear / A_rear + R_cover / Ai_rear);
    const UA_sides = 1 / (R_sides / A_sides + R_cover / Ai_sides);
    const wall_UA = UA_roof + UA_floor + UA_front + UA_rear + UA_sides;

    const params = {
        'wallThermalMass': C_box,
        'wallUANew': wall_UA
    };
    return params;
}
export default calculateUAParameters;